import { isAfter, isValid, parseISO } from 'date-fns';

import featureFlags from '../../configurations/feature-flags.json';
import { availableEnvironments, getEnv } from '../utilities/env';

type FeatureFlagConfig = {
    environments: string[]; // 'local' | 'staging' | 'production'
    endDate?: string; // Format 'YYYY-MM-DD'
    autoExpireEndDate?: string; // Format 'YYYY-MM-DD'
};

type FeatureFlagEnvType = Record<string, FeatureFlagConfig>;
export const featureFlagEnv: FeatureFlagEnvType = featureFlags;

export const getFeatureFlag = (flagName: keyof typeof featureFlagEnv): boolean => {
    const { search } = location;

    const params = new URLSearchParams(search);
    const urlQueryFeatureFlag = params.get(flagName);
    if (urlQueryFeatureFlag) {
        return urlQueryFeatureFlag === 'true';
    }

    const appEnv = getEnv('APP_ENV');

    if (typeof appEnv !== 'string' || !availableEnvironments.includes(appEnv)) {
        return false;
    }

    const flag = featureFlagEnv?.[flagName];

    const isEnvAllowed = flag?.environments?.includes(appEnv);

    if (!isEnvAllowed) {
        return false;
    }

    return !isFeatureFlagExpired(flag?.autoExpireEndDate);
};

const isFeatureFlagExpired = (autoExpireEndDate?: string): boolean => {
    if (!autoExpireEndDate) {
        return false;
    }
    const parsedDate = parseISO(autoExpireEndDate);
    if (!isValid(parsedDate)) {
        console.warn(`Invalid feature flag endDate : ${autoExpireEndDate}`);
        return false;
    }

    const now = new Date();
    return !isAfter(parsedDate, now);
};
